// extracted by mini-css-extract-plugin
module.exports = {"paginationContainer":"FeaturePagination_paginationContainer__a9FJf","leftToRight":"FeaturePagination_leftToRight__VltMu"};